import Spinner from "../Spinner";
import styles from "./styles.module.css";

type Props = {
  isMethodSelectorOpen: boolean;
  isCardOverlayOpen: boolean;
  isPaymentStarting: boolean;
  paymentError: string | null;
  cardPaymentKey: number;
  closeMethodSelector: () => void;
  closePaymentOverlay: () => void;
  startCardPayment: () => void;
  startSbpPayment: () => void;
};

export default function PaymentOverlays({
  isMethodSelectorOpen,
  isCardOverlayOpen,
  isPaymentStarting,
  paymentError,
  cardPaymentKey,
  closeMethodSelector,
  closePaymentOverlay,
  startCardPayment,
  startSbpPayment,
}: Props) {
  const showMethodSelector = isMethodSelectorOpen && !isCardOverlayOpen;

  return (
    <>
      {showMethodSelector && (
        <div
          className={`${styles.paymentOverlay} ${styles.paymentOverlayActive}`}
          onClick={() => {
            if (!isPaymentStarting) closeMethodSelector();
          }}
        >
          <div
            className={styles.methodSelectorCard}
            role="dialog"
            aria-modal="true"
            aria-label="Выберите способ оплаты"
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.methodSelectorHeader}>
              <div className={styles.methodSelectorTitle}>Выберите способ оплаты</div>
              <button
                type="button"
                className={styles.methodSelectorClose}
                onClick={() => closeMethodSelector()}
                disabled={isPaymentStarting}
                aria-label="Закрыть"
              >
                ×
              </button>
            </div>

            {paymentError && <div className={styles.error}>{paymentError}</div>}

            <div className={styles.methodList}>
              <button
                type="button"
                className={styles.methodButton}
                onClick={() => startSbpPayment()}
                disabled={isPaymentStarting}
              >
                <div className={styles.methodIcon}>
                  <img src="/sbp-logo.svg" alt="" />
                </div>
                <div className={styles.methodInfo}>
                  <div className={styles.methodTitle}>СБП</div>
                  <div className={styles.methodDesc}>Приложение вашего банка</div>
                </div>
              </button>
              <button
                type="button"
                className={styles.methodButton}
                onClick={() => startCardPayment()}
                disabled={isPaymentStarting}
              >
                <div className={styles.methodIcon}>
                  <img src="/card-logo.png" alt="" />
                </div>
                <div className={styles.methodInfo}>
                  <div className={styles.methodTitle}>Банковская карта</div>
                  <div className={styles.methodDesc}>Мир</div>
                </div>
              </button>
            </div>

            {isPaymentStarting && (
              <div className={styles.methodSelectorLoading}>
                <Spinner />
                <div className={styles.methodSelectorLoadingText}>Создаём платёж…</div>
              </div>
            )}
          </div>
        </div>
      )}

      {isCardOverlayOpen && (
        <div
          key={`card-${cardPaymentKey}`}
          className={`${styles.paymentOverlay} ${styles.paymentOverlayActive}`}
          onClick={() => closePaymentOverlay()}
        >
          <div
            className={styles.paymentOverlayCard}
            role="dialog"
            aria-modal="true"
            aria-label="Форма оплаты"
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.paymentOverlayHeader}>
              <button
                type="button"
                className={styles.paymentOverlayClose}
                onClick={() => closePaymentOverlay()}
                aria-label="Закрыть"
              >
                ×
              </button>
            </div>
            <div id="smgl-payment-form" className={styles.widgetMount}></div>
          </div>
        </div>
      )}
    </>
  );
}
